import { cva } from 'class-variance-authority';

export const contextMenuContainerStyles = cva([
  'flex',
  'flex-col',
  'bg-white',
  'border',
  'border-grey-200',
  'rounded-md',
  'z-30',
  'shadow-lg',
  'max-md:min-w-46.5',
  'max-md:max-w-[calc(100vw-2rem)]',
  'max-md:py-1',
  'max-md:[&>*:last-child>button]:border-b-0',
]);

export const contextMenuItemStyles = cva(
  [
    'flex',
    'items-center',
    'gap-3',
    'w-full',
    'px-3.5',
    'py-1.5',
    'max-md:p-4',
    'max-md:leading-normal',
    'text-body-small',
    'text-black',
    'cursor-pointer',
    'max-md:border-b',
    'max-md:border-grey-200',
    'hover:bg-blue-50',
    'transition-colors',
    'duration-100',
  ],
  {
    variants: {
      isDanger: {
        true: ['text-red-500', 'hover:bg-red-50'],
      },
      isDisabled: {
        true: ['text-neutral-400', 'cursor-not-allowed', 'hover:bg-transparent'],
      },
      hideDivider: {
        true: ['max-md:border-b-0'],
      },
    },
    defaultVariants: {
      isDanger: false,
      isDisabled: false,
      hideDivider: false,
    },
  }
);
